import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CampaignConfirmTemplate } from 'components/Templates'

const CampaignConfirm: FC = () => {
  return (
    <Layout headline={'キャンペーン'} iconPath={'/icon/white/cms.svg'} title={'確認 | キャンペーンの編集'}>
      <CampaignConfirmTemplate />
    </Layout>
  )
}

export default CampaignConfirm
